import {createAsyncThunk} from '@reduxjs/toolkit';
import api, {CustomAxiosConfig} from 'services/axios';
import {generatedUDID} from 'utils/Helper';

export const loginWithNoPass = createAsyncThunk<any, any>(
  'loginWithNoPass',
  async (formData: FormData) => {
    const res = await api.post(`/mobile/v4/user/loginMobileWithNoPass`, formData, {
      goBaseUrl: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  }
);

export const loginMobieWithToken = createAsyncThunk<any, any>(
  'loginMobieWithToken',
  async (data: any) => {
    const res = await api.post(
      `/mobile/v2/user/loginMobileWithToken?UDID=${generatedUDID('UDID', 365)}`,
      data,
      {
        goBaseUrl: true
      }
    );
    return res.data;
  }
);

export const registerWithOptionalPass = createAsyncThunk<any, any>(
  'registerWithOptionalPass',
  async (data: any) => {
    const res = await api.post(
      `/mobile/v1/user/registerWithOptionalPass?UDID=${generatedUDID('UDID', 365)}`,
      data,
      {
        goBaseUrl: true
      }
    );
    return res.data;
  }
);

export const getRegisterStatus = createAsyncThunk<any, void>('getRegisterStatus', async () => {
  const {data} = await api.get(`/public/registration/status`, {
    vendorHubBaseUrl: true
  } as CustomAxiosConfig);
  return data.data;
});

export const sendPersonalInfo = createAsyncThunk<any, any>(
  'sendPersonalInfo',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/registrations/info/general`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getSoftwareTypes = createAsyncThunk<any, any>(
  'getSoftwareTypes',
  async (_, thunkApi) => {
    try {
      const response = await api.get(`/public/software/types`, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getDeliveryTypes = createAsyncThunk<any, any>(
  'getDeliveryTypes',
  async (_, thunkApi) => {
    try {
      const response = await api.get(`/public/delivery/types`, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendVendorInfo = createAsyncThunk<any, any>(
  'sendVendorInfo',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/registrations/info/vendor`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendBankInfo = createAsyncThunk<any, any>(
  'sendBankInfo',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/registrations/info/bank`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendPostalInfo = createAsyncThunk<any, any>(
  'sendPostalInfo',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/post/info`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendIbanInfo = createAsyncThunk<any, any>(
  'sendIbanInfo',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/iban/info`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendSabtahvalInfo = createAsyncThunk<any, any>(
  'sendSabtahvalInfo',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/sabtahval/info`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendDocument = createAsyncThunk<any, any>(
  'sendDocument',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/registrations/documents`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendContract = createAsyncThunk<any, any>(
  'sendContract',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/registrations/contract/confirm`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const uploadFile = createAsyncThunk<any, any>(
  'uploadFile',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/documents/upload`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendOtp = createAsyncThunk<any, any>('sendOtp', async (params: any, thunkApi) => {
  try {
    const response = await api.post(
      `mobile/v4/user/loginMobileWithNoPass?client=PWA&optionalClient=PWA&deviceType=PWA&appVersion=5.6.6&clientVersion=a4547bd9&optionalVersion=5.6.6&UDID=494ea2fe-71a6-4d90-933b-7bc471298eea&lat=35.774&long=51.418`,
      params,
      {
        vendorHubLogin: true
      }
    );
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const downloadPdfContract = createAsyncThunk<
  Blob, // return type
  {trackingNumber: string}, // arg type
  {rejectValue: string} // reject type
>('contracts/downloadPdfContract', async ({trackingNumber}, {rejectWithValue}) => {
  try {
    const res = await api.get(`/public/registrations/contract/${trackingNumber}/pdf`, {
      vendorHubBaseUrl: true,
      responseType: 'arraybuffer', // <-- CRUCIAL
      headers: {Accept: 'application/pdf'}
    } as CustomAxiosConfig & {responseType: 'arraybuffer'});

    const contentType = res.headers?.['content-type'] ?? res.headers?.['Content-Type'];
    const mime =
      typeof contentType === 'string' ? contentType.split(';')[0].trim() : 'application/pdf';
    return new Blob([res.data], {type: mime});
  } catch (err: any) {
    return rejectWithValue(err?.message ?? 'Failed to download PDF');
  }
});

export const downloadPdfSignedContract = createAsyncThunk<
  Blob, // return type
  {trackingNumber: string}, // arg type
  {rejectValue: string} // reject type
>('contracts/downloadPdfSignedContract', async ({trackingNumber}, {rejectWithValue}) => {
  try {
    const res = await api.get(`/public/registrations/contract/${trackingNumber}/signed-pdf`, {
      vendorHubBaseUrl: true,
      responseType: 'arraybuffer', // <-- CRUCIAL
      headers: {Accept: 'application/pdf'}
    } as CustomAxiosConfig & {responseType: 'arraybuffer'});

    const contentType = res.headers?.['content-type'] ?? res.headers?.['Content-Type'];
    const mime =
      typeof contentType === 'string' ? contentType.split(';')[0].trim() : 'application/pdf';
    return new Blob([res.data], {type: mime});
  } catch (err: any) {
    return rejectWithValue(err?.message ?? 'Failed to download PDF');
  }
});

export const identityVerification = createAsyncThunk<any, void>(
  'identityVerification',
  async (_params, thunkApi) => {
    try {
      const response = await api.get(`/public/registrations/kyc/identity/verification`, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendFaceRecognitionInfo = createAsyncThunk<any, any>(
  'sendFaceRecognitionInfo',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/registrations/kyc/face-recognition`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendSignatureInfo = createAsyncThunk<any, any>(
  'sendSignatureInfo',
  async (params: any, thunkApi) => {
    try {
      const response = await api.post(`/public/registrations/contract/sign`, params, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const sendKycOtpCode = createAsyncThunk<any, void>(
  'sendKycOtpCode',
  async (_params, thunkApi) => {
    try {
      const response = await api.get(`/public/registrations/kyc/otp/send`, {
        vendorHubBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
